import React from 'react';
import { UnitCreators } from '@leverege/api-attributes';
import BooleanEditor from './BooleanEditor';
import IntEditor from './IntEditor';
import NumberEditor from './NumberEditor';
import UnitEditor from './UnitEditor';
import PercentEditor from './PercentEditor';
import StringEditor from './StringEditor'
import TimestampEditor from './TimestampEditor'
import GeoJsonEditor from '../../viewers/GeoJsonViewer'
import GeoPointEditor from './GeoPointEditor'
import EnumEditor from './EnumEditor'
import ResourceEnumEditor from './ResourceEnumEditor'
import ParentRelationshipEditor from './ParentRelationshipEditor'

function createEditor( attribute, prps ) {

  if ( attribute == null ) {
    return null;
  }
  
  const props = {
    ...prps,
    attribute  
  }

  switch ( attribute.type ) {
    case BooleanEditor.TYPE: return <BooleanEditor {...props} />
    case IntEditor.TYPE: return <IntEditor {...props} />
    case NumberEditor.TYPE: return <NumberEditor {...props} />
    case PercentEditor.TYPE: return <PercentEditor {...props} />
    case StringEditor.TYPE: return <StringEditor {...props} />
    case TimestampEditor.TYPE: return <TimestampEditor {...props} />
    case GeoJsonEditor.TYPE: return <GeoJsonEditor {...props} />
    case GeoPointEditor.TYPE: return <GeoPointEditor {...props} />
    case EnumEditor.TYPE: return <EnumEditor {...props} />
    case ResourceEnumEditor.TYPE: return <ResourceEnumEditor {...props} />
    case ParentRelationshipEditor.TYPE: return <ParentRelationshipEditor {...props} />
    // case RandomBooleanEditor.TYPE : return <RandomBooleanEditor {...props}/>

    // Handle any explicity units here.
    default: {
      const uTypes = UnitCreators.getCreators();
      for ( let n = 0; n < uTypes.length; n++ ) {
        if ( uTypes[n].typeName() === attribute.type ) {
          return <UnitEditor {...props} />
        }
      }
    }
  }
  
  return <div /> 
}

module.exports = {
  createEditor
}
